import { useEffect, useRef, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";

type MemberStatus = { uid:string; name:string; deviceCount:number; deviceCountLimited:boolean; lastRegistrationAt:number|null; familyPing:boolean; homeHuntStart:boolean; homeHuntWinner:boolean; huntStart:string; huntWinner:string };
type Status = { checkedAt:number; members:MemberStatus[] };
const fetchStatus = httpsCallable<{householdId:string},Status>(functions,"getHouseholdPushStatus");
export function HouseholdPushStatus({householdId}:{householdId:string}) {
  const [status,setStatus]=useState<Status|null>(null);
  const [busy,setBusy]=useState(false);
  const [error,setError]=useState("");
  const active=useRef(true);
  useEffect(()=>{active.current=true;return()=>{active.current=false;};},[]);
  async function refresh(){
    setBusy(true);setError("");setStatus(null);
    try { const result=await fetchStatus({householdId});if(active.current)setStatus(result.data); }
    catch { if(active.current)setError("Could not load family device status. Check that the notification service has been deployed, then retry."); }
    finally {if(active.current)setBusy(false);}
  }
  return <details className="notification-family-status">
    <summary>Family notification status · Admin</summary>
    <p className="connection-note">Counts are saved push registrations, not physical phones. Old registrations and separate browsers can count more than once. Accepted means the push service accepted an alert; it does not confirm phone display.</p>
    <button type="button" className="notification-small-button" disabled={busy} onClick={()=>void refresh()}>{busy?"Checking…":"Refresh status"}</button>
    {error&&<p role="alert" className="connection-note">{error}</p>}
    {status&&<><p className="connection-note" role="status">Checked {new Date(status.checkedAt).toLocaleTimeString()}</p>
      {status.members.map(member=><article className="notification-member-status" key={member.uid}>
        <strong>{member.name} · {member.deviceCount}{member.deviceCountLimited?"+":""} saved {member.deviceCount===1?"registration":"registrations"}</strong>
        {!member.deviceCount&&<p>No saved registration. Open the installed app on their phone and enable alerts.</p>}
        <p>Last registration: {member.lastRegistrationAt?new Date(member.lastRegistrationAt).toLocaleString():"None recorded"}</p>
        <p>Ping: {member.familyPing?"On":"Off"} · Hunt starts: {member.homeHuntStart?"On":"Off"} · Winner: {member.homeHuntWinner?"On":"Off"}</p>
        <p>Today’s hunt: {member.huntStart}<br/>Winner alert: {member.huntWinner}</p>
      </article>)}
    </>}
  </details>;
}
